import { useState } from "react"
import { Globe, Linkedin, Mail } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { cn, iniciais } from "@/lib/utils"
import { appInfo } from "@/lib/appInfo"

const LINKS = [
  {
    rotulo: appInfo.site,
    href: appInfo.site,
    icone: Globe,
    texto: appInfo.site.replace(/^https?:\/\//, ""),
  },
  {
    rotulo: appInfo.email,
    href: appInfo.email ? `mailto:${appInfo.email}` : "",
    icone: Mail,
    texto: appInfo.email,
  },
  {
    rotulo: appInfo.linkedin,
    href: appInfo.linkedin,
    icone: Linkedin,
    texto: appInfo.linkedin.replace(/^https?:\/\/(www\.)?/, ""),
  },
].filter((link) => link.href)

/** Nome, versão e créditos do sistema — compacto; os detalhes ficam no modal. */
export function AuthorFooter({ className }: { className?: string }) {
  const [aberto, setAberto] = useState(false)

  return (
    <>
      <div
        className={cn(
          "flex flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5 text-xs text-muted-foreground",
          className,
        )}
      >
        <span className="font-medium text-foreground">{appInfo.nome}</span>
        <span>v{appInfo.versao}</span>
        <span aria-hidden>·</span>
        <button
          type="button"
          onClick={() => setAberto(true)}
          className="underline-offset-2 transition-colors hover:text-foreground hover:underline"
        >
          Créditos
        </button>
      </div>

      <Dialog open={aberto} onOpenChange={setAberto}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Créditos</DialogTitle>
            <DialogDescription>{appInfo.descricao}</DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div className="flex items-center gap-3 rounded-lg border bg-muted/30 p-3">
              <span className="flex size-11 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
                {iniciais(appInfo.autor)}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-foreground">
                  {appInfo.autor}
                </p>
                <p className="text-xs text-muted-foreground">
                  Autor e desenvolvedor do sistema
                </p>
              </div>
            </div>

            <div className="space-y-1.5">
              {LINKS.map((link) => {
                const Icone = link.icone
                return (
                  <a
                    key={link.href}
                    href={link.href}
                    target={link.href.startsWith("mailto:") ? undefined : "_blank"}
                    rel="noreferrer"
                    className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                  >
                    <Icone className="size-4 shrink-0" />
                    <span className="truncate">{link.texto}</span>
                  </a>
                )
              })}
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setAberto(false)}>
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
